function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  "data-name": "Raggruppa 3688",
  opacity: 0.7
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Tracciato 3563",
  d: "M20.455 57.995l1.486-4.457c.742-2.229 5.2-7.429 5.2-7.429l8.913-8.913 12.629 2.229 2.228 12.628.582 4.417-7.268 14.9-4.457 5.942-20.056-11.141z",
  fill: "#eae8e5"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Tracciato 3564",
  d: "M63.16 31.339a13.521 13.521 0 00.379 1.4 62.182 62.182 0 002.972 7.429l-3.716.742s.744 15.6-2.971 16.342-12.628-1.486-16.343-3.715-6.685-6.685-6.685-9.656a10.283 10.283 0 00-1.485-5.2l-2.229.743-2.229-17.085 25.257-8.17 8.17 2.228-1.485 4.457a40.681 40.681 0 00.365 10.485z",
  fill: "#eae8e5"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Tracciato 3565",
  d: "M21.942 53.536s12.628-.742 13.371-8.17-.743-7.429-1.486-8.915-2.972-5.941.743-8.17 6.685 4.456 6.685 4.456.2-10.478 3.714-11.885c3.715-1.484 13.371 0 13.371 0s15.916.522 12.628-12.628c-3.713-14.855-24.513-5.2-29.713-4.458s-16.872 2.455-20.8 5.943c-6.685 5.942-3.045 12.408.744 23.771 2.971 8.914.743 20.056.743 20.056z",
  fill: "#726e68"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Tracciato 3566",
  d: "M21.942 53.536s12.628-.742 13.371-8.17-.743-7.429-1.486-8.915-2.972-5.941.743-8.17 6.685 4.456 6.685 4.456.2-10.478 3.714-11.885c3.715-1.484 13.371 0 13.371 0s15.916.522 12.628-12.628c-3.713-14.855-24.513-5.2-29.713-4.458s-16.872 2.455-20.8 5.943c-6.685 5.942-3.045 12.408.744 23.771 2.971 8.914.743 20.056.743 20.056z",
  fill: "#726e68"
}), /*#__PURE__*/React.createElement("circle", {
  "data-name": "Ellisse 477",
  cx: 4.426,
  cy: 4.426,
  r: 4.426,
  transform: "translate(38.168 31.161)",
  fill: "none",
  stroke: "#c1a42d",
  strokeMiterlimit: 10,
  strokeWidth: 0.599
}), /*#__PURE__*/React.createElement("circle", {
  "data-name": "Ellisse 478",
  cx: 3.509,
  cy: 3.509,
  r: 3.509,
  transform: "translate(39.085 32.077)",
  fill: "none",
  stroke: "#c1a42d",
  strokeMiterlimit: 10,
  strokeWidth: 0.524
}), /*#__PURE__*/React.createElement("circle", {
  "data-name": "Ellisse 479",
  cx: 2.592,
  cy: 2.592,
  r: 2.592,
  transform: "translate(40.001 32.995)",
  fill: "none",
  stroke: "#c1a42d",
  strokeMiterlimit: 10,
  strokeWidth: 0.449
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Raggruppa 2234",
  fill: "#c1a42d"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Tracciato 3567",
  d: "M41.851 30.552a2.375 2.375 0 00-.382-.912c-.154 1.43-.2 2.567-.211 2.952a2.367 2.367 0 00.593-2.04z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Tracciato 3568",
  d: "M21.905 36.115a8.483 8.483 0 01-1.628.144 1.063 1.063 0 00-.338 0 1.015 1.015 0 00.175 2.014h.017a18.5 18.5 0 002.165-.114q-.155-1.027-.378-2.048z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Tracciato 3569",
  d: "M32.665 30.626c-1.283.722-2.643 1.482-3.949 2.214l-4.076 2.284-.07.03a8.536 8.536 0 01-2.649.964c.149.68.273 1.362.379 2.048.308-.036.629-.082.952-.141 1.181-.219 2.338-.833 2.946-.945a2.249 2.249 0 01.356-.095 2.368 2.368 0 011.356.146l.056.024a4.3 4.3 0 001.5.2 2.375 2.375 0 00.34-.089l1.2-.669c1.032-.575 1.948-1.084 2.282-1.272a7.243 7.243 0 01-.623-4.699z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Tracciato 3570",
  d: "M45.599 35.728l-.709-1.786-1.795-4.613-.048-.071a3.486 3.486 0 00-3.869-2.147 3.654 3.654 0 00-.431.108l-1.511.846a4.794 4.794 0 011.249.794 2.4 2.4 0 01.6-.207 2.371 2.371 0 012.171 3.943c-.016.018-.035.029-.05.045a2.361 2.361 0 01-1.079.635l-.109.043a1.373 1.373 0 00-.771 1.783l1.077 2.718a1.377 1.377 0 001.785.771l2.718-1.077a1.378 1.378 0 00.772-1.785z"
})), /*#__PURE__*/React.createElement("path", {
  "data-name": "Tracciato 3571",
  d: "M61.309 89.194c-5.2-7.429-17.084-17.828-17.084-17.828l-2.228 2.972-21.543-16.343S6.341 67.651 1.883 79.536c-.906 2.416-1.5 6.766-1.884 12.159a62.523 62.523 0 0040.521 14.834 63.173 63.173 0 0010.258-.839 63.623 63.623 0 002.328-.424 62.345 62.345 0 0016.324-5.778c-2.69-3.162-5.783-6.953-8.121-10.294z",
  fill: "#a5a093"
}));

function SvgHeadphones(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 71.415 106.529"
  }, props), _ref);
}

export default SvgHeadphones;